var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandwindowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#262a2e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M800-250v-460h60v460h-60Zm-313.46-4.23L443.77-296l154-154H100v-60h497.39L444.77-664l41.77-41.77L712.31-480 486.54-254.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandwindowIcon);
export default __webpack_public_path__ + "static/media/expandwindow_icon.4ac469aa8ee35ea7ada70d2d4db8f60e.svg";
export { ForwardRef as ReactComponent };